import { getTextsData } from "selectors/texts";
import { getUserBusinessesData } from "selectors/businesses";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import IntegrationServices from "const/IntegrationServices";
import IntegrationsActions from "actions/IntegrationsActions";
import UiActions from "actions/UiActions";

const useAddNewBusiness = () => {
  const dispatch = useDispatch();

  const { messages, uiTexts } = useSelector(getTextsData);

  const businessesData = useSelector(getUserBusinessesData);

  return useCallback(async(params) => {
    const { integrationService } = params;

    const manualIntegrationFlow = integrationService === IntegrationServices.QUICK_BOOKS_DESKTOP.value;

    dispatch(UiActions.togglePreloader(true));
    if (manualIntegrationFlow) {
      dispatch(UiActions.togglePreloader(false));
      dispatch(UiActions.showAddQuickBooksDesktopWindow());
    } else {
      const consentUrl = await dispatch(IntegrationsActions.buildConsentUrl(
        integrationService,
        { rpaMode: !!params.rpaMode }
      ));

      if (consentUrl) {
        window.location.href = consentUrl;

        return;
      } dispatch(UiActions.togglePreloader(false));
    }
    if (!manualIntegrationFlow && !businessesData.length) {
      await dispatch(UiActions.showModal(messages.addFirstBusiness, uiTexts.warning));
    }
  }, [businessesData, messages, uiTexts, dispatch]);
};

export default useAddNewBusiness;
